import * as t from 'io-ts';
import {map} from 'lodash';

import {makeApiType, makeEnumRuntimeType} from './apiTypes';
import {parseContact} from './contactModel';
import {RecipientRolesEnum} from './recipientModel';
import {RVisualContact} from './visualContactModel';

/*
 * Runtime type.
 */

const RVisualRecipientDirty = t.readonly(
  t.intersection([
    RVisualContact,
    t.type({
      role: makeEnumRuntimeType(RecipientRolesEnum),
    }),
  ]),
);

/*
 * Type.
 */

export interface VisualRecipientModel extends t.TypeOf<typeof RVisualRecipientDirty> {}
export const RVisualRecipient = t.clean<VisualRecipientModel>(RVisualRecipientDirty as any);
const RVisualRecipients = t.readonlyArray(RVisualRecipient);

/*
 * IO methods.
 */

export function parseGroupVisualRecipient(src: any): VisualRecipientModel {
  return {
    role: RecipientRolesEnum.TO,
    contact: parseContact(src),
    name: src.name || undefined,
    namespace: 'global',
  };
}

export function parseGroupVisualRecipients(src: any) {
  return map(src.contacts, parseGroupVisualRecipient);
}

/*
 * API type.
 */

export const ApiGroupVisualRecipients = makeApiType(
  'groupVisualRecipients',
  RVisualRecipients,
  parseGroupVisualRecipients,
);
